import React, { Component } from 'react';
import moment from 'moment';

import LocalDataManager from '../managers/LocalDataManager';
import StackUpService from '../services/StackUpService';
import GroupsService from '../services/GroupsService';

import StackupFreeTopBar from './StackupFree/StackupFreeTopBar';
import StackupFreeViewCentral from './StackupFree/StackupFreeViewCentral';
import StackupFreeBottomBar from './StackupFree/StackupFreeBottomBar';

export default class StackupFreePage extends Component {
    constructor(props) {
        super(props);

        window.zzActiveObject = this;

        this.dbm = new LocalDataManager();
        this.stackService = new StackUpService();
        this.groupsService = new GroupsService();

        this.state = {
            screenContext: {
                mode: 'locs',
                range: 'YTD',
                resetSlider: true,
                tagList: {},
                groupList: {},
                masterKpiList: {},
                locationList: [],
                selectedLocation: {},
                sortBy: 'NAME',
                sortByDir: 'ASC',
                selectKpiMode: false,
                selectedKpiList: window.localStorage.selectedKpiList != undefined ? JSON.parse(window.localStorage.selectedKpiList)
                    : ['Total Sales', 'Service Sales', 'Product Sales', 'Customer Count', 'New Customers', 'Productivity']
            },
            tagFilter: {
                clientAccountId: '',
                tags: [],
                groups: [],
                filterDate: moment().format("MM/DD/YYYY"),
                userTypeId: 6,
                locationIds: []
            },
            stackData: [],
            isScrollTop: true,
            selectedItems: [],
            searchText: '',
            searchTop: 0,
            swipeMode: 0,
            accountInfo: null,
        }

        this.settings = this.dbm.getSettingsInfo();

        this.stackupInit = this.stackupInit.bind(this);
        this.updateStackup = this.updateStackup.bind(this);
        this.organizeTags = this.organizeTags.bind(this);

        this.handleScrollTop = this.handleScrollTop.bind(this);

        this.changePeriod = this.changePeriod.bind(this);
        this.changeDate = this.changeDate.bind(this);

        this.saveTags = this.saveTags.bind(this);

        window.zzResume = () => { };
        window.zzPause = () => { };

        let self = this;
        self.props.superInit(self.stackupInit, undefined, () => { self.updateStackup() }, undefined);
    }

    stackupInit() {

        let self = this;

        this.dbm.getAccountInfo().then((accountInfo) => {

            let screenContext = self.state.screenContext;
            screenContext.locationList = [];

            let tagFilter = self.state.tagFilter;
            tagFilter.clientAccountId = "";
            tagFilter.userTypeId = accountInfo.userType;
            tagFilter.locationIds = [];

            self.stackService.masterKpis(mkres => {

                let tmpMkList = {}
                mkres.forEach(mk => {
                    tmpMkList[mk.masterKpiId] = mk;
                });
                screenContext.masterKpiList = tmpMkList;

                self.stackService.tags((tagRes) => {

                    screenContext.tagList = self.organizeTags(tagRes);

                    let tempTagIds = [];
                    for (var i = 0; i < tagRes.length; i++) {
                        tempTagIds.push(tagRes[i].tagId);
                    }

                    tagFilter.tags = [];

                    self.groupsService.getGroupsForStackup({
                        clientAccountId: "",
                        userId: accountInfo.userId
                    }, (groups) => {

                        let tmpGroupMap = {};
                        groups.forEach(g => {
                            let gkey = g.groupId;
                            if (!tmpGroupMap[gkey]) {
                                tmpGroupMap[gkey] = {
                                    groupId: g.groupId,
                                    name: g.name,
                                    description: g.description
                                }
                            }
                        });

                        screenContext.groupList = tmpGroupMap;
                        tagFilter.groups = [];

                        self.stackService.stackupFree(tagFilter, (stackRes) => {

                            let tmpStackData = stackRes;

                            screenContext.locationList = [];

                            self.setState({ screenContext: screenContext, accountInfo: accountInfo, tagFilter: tagFilter, stackData: tmpStackData }, () => {
                                self.props.loadingOff();
                                setTimeout(() => {
                                    screenContext.mode = 'main';
                                    self.setState({ screenContext: screenContext });
                                }, 250);
                            });
                        }, (err) => {
                            self.props.loadingOff();

                            alert("An error occurred. Please try again later.");
                            self.props.changePage('leaderboard', false);
                        });

                    }, (err) => {
                        self.props.loadingOff();

                    });

                }, (err) => {
                    self.props.loadingOff();

                });
            }, err => {
                self.props.loadingOff();
            });
        }, (err) => {
            self.props.loadingOff();
        });
    }

    updateStackup() {
        let self = this;
        self.props.loadingOn();

        let locationList = [];
        let tagFilter = self.state.tagFilter;
        let screenContext = this.state.screenContext;

        self.stackService.stackupFree(tagFilter, (stackRes) => {

            let tmpStackData = stackRes;

            self.setState({ screenContext: screenContext, stackData: tmpStackData }, () => {
                self.props.loadingOff();
            });
        }, (err) => {
            self.props.loadingOff();
        });

    }

    organizeTags(rawData) {

        let organizedData = {};

        for (var i = 0; i < rawData.length; i++) {

            if (!organizedData[rawData[i].category]) {
                organizedData[rawData[i].category] = []
            }

            organizedData[rawData[i].category].push(rawData[i]);
        }

        let categories = Object.keys(organizedData);
        for (var i = 0; i < categories.length; i++) {
            organizedData[categories[i]] = _.sortBy(organizedData[categories[i]], 'name');
        }

        return organizedData;
    }

    handleScrollTop(isScrollTop, scrollTop) {
        if (this.state.isScrollTop != isScrollTop) {
            this.scrollTop = scrollTop;
            this.setState({ isScrollTop: isScrollTop });
        }
    }

    changePeriod(range) {

        let screenContext = this.state.screenContext;
        screenContext.range = range;

        this.setState({ screenContext: screenContext });
    }

    changeDate(dateString, dateObject, event) {
        this.props.loadingOn();

        let tagFilter = this.state.tagFilter;
        tagFilter.filterDate = moment(dateObject).format("MM/DD/YYYY");

        let self = this;
        this.setState({ tagFilter: tagFilter }, () => {
            self.updateStackup();
        });
    }

    saveTags(tags, groups) {
        let tagFilter = this.state.tagFilter;

        let tempTags = [];
        for (var i = 0; i < tags.length; i++) {
            tempTags.push(tags[i].tagId);
        }

        tagFilter.tags = tempTags;

        tagFilter.groups = groups.map(x => x.groupId);

        let self = this;
        this.setState({ tagFilter: tagFilter }, () => {
            self.updateStackup();
        });
    }

    render() {

        return (
            <div id="page-outer" className={"stackup-page-outer stackup-page-outer-free"}>
                <StackupFreeTopBar
                    isScrollTop={this.state.isScrollTop}
                    toggleNav={this.props.toggleNav}
                />
                <StackupFreeViewCentral
                    handleScrollTop={this.handleScrollTop}
                    stackData={this.state.stackData}
                    screenContext={this.state.screenContext}
                    tagFilter={this.state.tagFilter}
                />
                <StackupFreeBottomBar
                    changeDate={this.changeDate}
                    selectedItems={this.state.selectedItems}
                    screenContext={this.state.screenContext}
                    changePeriod={this.changePeriod}
                    saveTags={this.saveTags}
                />
            </div>
        )
    }
}